export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask加密货币",
            h1B: "MetaMask加密货币银行",
            h1C: "DeFi Wallet加密货币",
            h1D: "Coinbase加密货币银行",
            h1E: "MetaMask储蓄银行",
            h1F: "Betterment",
            h2: "邀请好友",
            h3: "绑定提款账户",
            h4: "参与储蓄",
            h4B: "加密货币存款",
            h4C: "数字货币充值",
            h5: "精选理财",
            h5B: "秒合约交易",
            h5c: "存入",
            h6: "用户池",
            h7: "USDT账户",
            h8: "总产量",
            h9: "有效节点",
            h10: "参与者",
            h11: "收益",
            h12: "收益记录",
            h13: "地址",
            h14: "编号",
            h15: "常见问题",
            h16: "如何参与？",
            h17: "亲爱的用户，如果您想参与USDT钱包储蓄，需遵守平台用户规则，严格执行平台决定，接受风险部门的监督，您将自动获得存款权限。欢迎参与，谢谢。",
            h17B: "亲爱的用户，如果您想参与USDT钱包储蓄，需遵守平台用户规则，严格执行平台决定，接受风险部门的监督，您将自动获得存款权限。欢迎参与，谢谢。",
            h18: "如何提现？",
            h19: "每日产生的收益会自动存入账户余额，USDT提现成功后会自动添加到USDT钱包账户。若需提现日元，请联系客服中心处理。感谢您的参与与支持。",
            h19B: "每日产生的收益会自动存入账户余额，USDT提现成功后会自动添加到USDT钱包账户。如需使用其它提现方式，请咨询在线客服！",
            h20: "收入如何计算？",
            h21B: "以周期形式买入，VIP等级不同产生利润不同\nVIP1  $100~$5000，利率：1.8%\nVIP2  $5000~$20000，利率：2.6%\nVIP3  $20000~$50000，利率：3.5%\nVIP4  $50000~$80000，利率：4.7%\nVIP5  $80000~$120000，利率：5.3%\nVIP6  $120000~$160000，利率：6.2%\nVIP7  $160000~$200000，利率：7.3%\nVIP8    $200000以上，利率：8%\n\n",
            h21: "成功加入后，储蓄合约将开始计算收益。",
            h22: "储蓄的收益来自哪里？",
            h23: "用户参与储蓄后，储蓄合约生效。每天 00:00、12:00 共 2 次结算利息。储蓄合约生效后，资金进入托管模式，平台负责资金安全。为保障账户资金安全，请严格遵守平台规则，如有问题请联系在线客服。",
            h23B: "用户参与储蓄后，储蓄合约生效。每天 00:00、12:00 共 2 次结算利息。储蓄合约生效后，资金进入托管模式，平台负责资金安全。为保障账户资金安全，请严格遵守平台规则，如有问题请联系在线客服。",
            h24: "奖金是多少？",
            h25: "您可以分享我的平台给好友。当好友参与后，您可获得其首次入金金额20%的推荐奖励，并永久获得其收益10%的推荐佣金。分享的公开链接在首页右上角。",
            h25B: "您可以分享本平台给好友。当好友参与后，您可获得其首次入金金额20%的推荐奖励，并永久获得其收益10%的推荐佣金。分享链接在首页右上角。",
            h26: "可用余额",
            h27: "存入金额",
			
			h88: "平台背景",
			h89: "Betterment\n成立时间：2008 年\n总部：美国纽约\n定位：智能投顾（Robo-Advisor）与金融科技（FinTech），提供自动化投资组合与现金管理\n监管机构：受金融中心交易委员会（SEC） 监管，同时是 FINRA 成员\n客户规模：管理资产超过 400 亿美元\n客户群体：超过 80 万名个人与企业客户",
			h90: "平台优势",
			h91: "✔️ 美国最早的 Robo-Advisor，经验成熟\n✔️ 投资组合基于现代资产配置理论（MPT），分散风险\n✔️ 提供 税收优化功能\n✔️ 高利率现金账户，流动性强\n✔️ 全程数字化操作，界面简洁",
			h92: "适合人群",
			h93: "★ 想要长期稳健投资、不想频繁操作的用户\n★ 需要自动化理财、省时省心的年轻投资者\n★ 投资 + 高息储蓄 + 退休账户的人群\n★ 想要低成本进入金融市场的普通投资者",
			
            h28: "今日收益",
            h29: "总收益",
            h30: "提现",
            h31: "记录",
            h32: "可用余额",
            h33: "提现金额",
            h34: "请输入提现金额",
            h35: "全部",
            h36: "提现",
            h37: "常见问题",
            h38: "有安全审计报告",
            h39: "合作伙伴",
            h40: "我们的业务伙伴",
            h41: "显示银行卡号",
            h42: "上一页",
            h43: "下一页",
            h44: "已经是第一页",
            h45: "请输入提现金额",
            h46: "余额不足",
            h47: "已经是最后一页",
            h48: "收入",
            h49: "支出",
            h50: "操作过于频繁，请稍后再试。",
            h51: "审计报告",
            h52: "存币生息",
            h521: "存款生息",
            h53: "订单交易",
            h54: "注册奖励",
            h55: "邀请奖励",
            h56: "提现",
            h57: "充值",
            h58: "存款",
            h59: "取款",
            h591: "存入成功",
            h592: "存入失败",
            h593: "余额不足",
            h60: "通过加密货币转账赠送USDT",
            h61: "感谢一直大力支持MetaMask银行的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。（使用加密货币钱包提现同样享有此优惠）",
            h61B: "感谢一直大力支持Coinbase银行的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。",
            h61C: "感谢一直大力支持MetaMask银行的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。",
            h61D: "感谢一直大力支持Betterment的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。",
            h62: "您的取款金额为{amount}，手续费为{fee}%!",
            h63: "确认",
            h99: "待开放",
        },
        bankcard: {
            b1: "银行账户",
            b2: "金融机构名称",
            b3: "请输入金融机构名称",
            b4: "支行名称",
            b5: "请输入支行名称",
            b6: "支行号码",
            b7: "请输入支行号码",
            b8: "账号（普通）",
            b9: "请输入账号",
            b10: "假名",
            b11: "请输入用户名",
            b12: "账户名义",
            b13: "请输入账户名义人",
            b14: "绑定",
            b15: "虚拟币地址",
            b16: "请输入虚拟币地址",
        },
        usdt: {
            u1: "我的订单",
            u2: "存入",
            u3: "请选择合约时间：",
            u4: "买入价格：",
            u5: "请输入存入金额",
            u6: "增加买入",
            u7: "减少买入",
            u8: "操作成功",
            u9: "至少一点"
        },
        order: {
            o0: "我的订单",
            o1: "订单号",
            o2: "订单类型",
            o3: "买入金额",
            o4: "卖出金额",
            o5: "支付金额",
            o6: "合约时间",
            o7: "订单状态",
            o8: "结算状态",
            o9: "结算时间",
            o10: "下单时间",
            o11: "增加买入",
            o12: "减少买入",
            o13: "已卖出",
            o14: "盈利",
            o15: "亏损",
            o16: "已付费",
            o17: "盈亏平衡点"
        },
        recharge: {
            r1: "充值金额",
            r2: "充值金额数",
            r3: "充值类型",
            r4: "请选择",
            r5: "充值地址",
            r6: "转账交易订单号",
            r7: "已转账",
            r8: "审核中",
            r9: "输入不正确",
            r10: "请选择支付方式",
            r11: "最低充值金额为",
            r12: "充值上限金额为",
            r13: "请输入金额",
            r14: "上传支付截图",
            r15: "请上传支付截图",
            r16: "提交成功",
            r17: "取消",
            r18: "确认",
        },
        rechargeDetails: {
            r1: "充值记录",
            r2: "充值金额",
            r3: "审核中",
            r4: "充值成功",
            r5: "充值失败"
        },
		cert:{
			c1:"实名认证",
			c2:"真实姓名",
			c21:"请输入真实姓名",
			c3:"认证类型",
			c31:"身份证",
			c32:"护照",
			c33:"驾驶证",
			c10:"输入认证类型",
			c4:"证件正面",
			c41:"请上传证件正面",
			c5:"证件反面",
			c51:"请上传证件反面",
			c6:"提交",
			c7:"提交成功，等待审核中...",
			c8:"已通过认证",
			c9:"实名认证未通过，请重新上传",
			c11:"审核中",
			"传入字段不完整":"传入字段不完整",
			"已认证过":"已认证过",
			"审核中":"审核中"
		}
    }